// components/FilterPanel.jsx
import React from 'react';

const FilterPanel = ({
                         categories,
                         selectedCategory,
                         onCategoryChange,
                         tags,
                         selectedTags,
                         onTagChange,
                         sortBy,
                         onSortChange,
                         onClearFilters
                     }) => {
    const hasActiveFilters = selectedCategory || selectedTags.length > 0 || sortBy !== 'createdAt';

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6 sticky top-4">
            {/* Header */}
            <div className="flex items-center justify-between">
                <h2 className="text-lg font-bold text-gray-900">Filters</h2>
                {hasActiveFilters && (
                    <button
                        onClick={onClearFilters}
                        className="text-sm text-blue-600 hover:text-blue-700 font-medium"
                    >
                        Clear All
                    </button>
                )}
            </div>

            <div className="space-y-6">
                {/* Category Filter */}
                <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-3">
                        Category
                    </label>
                    <select
                        value={selectedCategory}
                        onChange={(e) => onCategoryChange(e.target.value)}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-gray-700 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    >
                        <option value="">All Categories</option>
                        {categories.map(category => (
                            <option key={category} value={category}>{category}</option>
                        ))}
                    </select>
                </div>

                {/* Tags Filter */}
                <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-3">
                        Tags
                    </label>
                    <div className="flex flex-wrap gap-2">
                        {tags.map(tag => (
                            <button
                                key={tag}
                                onClick={() => onTagChange(tag)}
                                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                                    selectedTags.includes(tag)
                                        ? 'bg-blue-600 text-white shadow-md'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {tag.charAt(0).toUpperCase() + tag.slice(1)}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Sort By */}
                <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-3">
                        Sort By
                    </label>
                    <select
                        value={sortBy}
                        onChange={(e) => onSortChange(e.target.value)}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-gray-700 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    >
                        <option value="createdAt_desc">Newest First</option>
                        <option value="createdAt_asc">Oldest First</option>
                        <option value="super_price_asc">Price: Low to High</option>
                        <option value="super_price_desc">Price: High to Low</option>
                        <option value="name_asc">Name: A to Z</option>
                        <option value="name_desc">Name: Z to A</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default FilterPanel;